// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the House Icon.
 * @param {IconProps} props - The IconProps for the HouseIcon component.
 * @returns {ReactElement} The HouseIcon component.
 */
export const HouseIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon width='17' height='15' viewBox='0 0 17 15' color={color} {...rest} id='house'>
      <path
        d='M16.7168 7.14844C16.9101 7.31836 16.9277 7.59082 16.7314 7.81055C16.5879 8.00391 16.289 8.02148 16.0957 7.8252L15 6.8584V12.6562C15 13.9512 13.9512 15 12.6562 15H4.21875C2.92442 15 1.875 13.9512 1.875 12.6562V6.8584L0.779009 7.8252C0.584771 8.02148 0.288551 8.00391 0.117281 7.81055C-0.0540171 7.59082 -0.0355015 7.31836 0.158619 7.14844L8.12694 0.117246C8.30566 -0.039082 8.56933 -0.039082 8.74804 0.117246L16.7168 7.14844ZM4.21875 14.0625H6.09375V9.375C6.09375 8.85645 6.51269 8.4375 7.03124 8.4375H9.84374C10.3623 8.4375 10.7812 8.85645 10.7812 9.375V14.0625H12.6562C13.4326 14.0625 14.0625 13.4326 14.0625 12.6562V6.05566L8.43749 1.09395L2.8125 6.05566V12.6562C2.8125 13.4326 3.44238 14.0625 4.21875 14.0625ZM7.03124 14.0625H9.84374V9.375H7.03124V14.0625Z'
        fill='currentColor'
      />
    </Icon>
  );
};
